export default "__VITE_ASSET__DBiqXf2e__"